import { hydrateRoot } from "react-dom/client";
import { App, localeFromPath, pageFromPath } from "./App";
import { locales, type Locale } from "./i18n";

function browserLocale(): Locale | undefined {
  const preferred = (navigator.languages?.[0] || navigator.language || "").toLowerCase().split("-")[0];
  return preferred === "fr" || preferred === "de" ? preferred : undefined;
}

function shouldRedirectFromRoot() {
  if (window.location.pathname !== "/") return undefined;
  try {
    const stored = window.localStorage.getItem("preferred_locale");
    if (stored && locales.includes(stored as Locale)) return undefined;
    const preferred = browserLocale();
    if (!preferred) return undefined;
    window.localStorage.setItem("preferred_locale", preferred);
    return `/${preferred}/`;
  } catch {
    return browserLocale() ? `/${browserLocale()}/` : undefined;
  }
}

const redirectPath = shouldRedirectFromRoot();
if (redirectPath) {
  window.location.replace(redirectPath);
} else {
  hydrateRoot(
    document.getElementById("root") as HTMLElement,
    <App page={pageFromPath(window.location.pathname)} locale={localeFromPath(window.location.pathname)} />
  );
}
